import ActionTypes from "../../../enums/ActionTypes"

export default function (state = {}, action) {
  switch (action.type) {
    case ActionTypes.WORKBENCH_FILTER_FORM_SET_VALUES: {
      const { payload } = action

      return {
        ...state,
        values: payload,
      }
    }
    default:
      return state
  }
}
